export default {
    packages_main_title: 'Paquetes',
    packages_main_add_packages: 'Agregar Paquete',
    packages_main_name: 'Nombre',
    packages_main_project: 'Plataforma',
    packages_main_dealer: 'Marca',
    packages_main_created_at: 'Creado en',
    packages_main_edit: 'Editar',
    packages_main_account: 'Cuenta',
    packages_main_assigned: 'Asignado',
    packages_main_temaple: '* Plantilla',
};